<!-- ------New html of Create sites and applications----------- -->
<!--breadcrumb_-->
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a>{{company_name}}:</a></li>
    <li class="active"><a>Edit Sites & Applications</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">

        <form [formGroup]="uForm" (ngSubmit)="saveSite()">
          <div class="newform_outer SAform">
            <div class="filter_div">
              <div class="top">
                <h4>{{showEditUsertxt}}</h4>
              </div>
            </div>
            <div class="row m_b_0">
              <div class="col-md-12 outer">
                <div class="col col-sm-6">
                  <h4>Site Details</h4>
                  <div class="row">
                    <div class="col-md-12">
                      <label>Name *</label>
                      <input type="text" class="form-control" formControlName="site_name" id="site_name">
                    </div>
                  </div>
                  <div class="row m_b_0">
                    <div class="col-md-12">
                      <label>Description</label>
                      <textarea class="form-control" formControlName="site_description"
                        id="site_description"></textarea>
                    </div>
                  </div>

                  <div class="col-md-12 p_0">
                    <label>Address 1 *</label>
                    <input type="text" class="form-control" formControlName="site_address1" id="site_address1">
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <label>Country *</label>
                      <select  id="site_country" formControlName="site_country"  class="custom_select form-control"  (change)="onCountryChange($event.target.value)">
                        <option value="">Select Country</option>
                        <option *ngFor="let country of countries" [value]="country.id">{{country.name}}</option>
                     </select>

                    </div>

                    <div class="col-md-6">
                      <label>State *</label>
                      <select id="site_state" formControlName="site_state" class="custom_select form-control">
                        <option value="">Select State</option>
                        <option *ngFor="let state of states" [value]="state.id">{{state.name}}</option>
                     </select>
                    </div>
                  </div>

                  <div class="col-md-12 p_0">
                    <label>City *</label>
                    <input type="text" class="form-control" formControlName="site_city" id="site_city">
                  </div>
                </div>
                <div class="col col-sm-6">
                  <h4>Application Details  </h4>
                  <!-- <pre>{{uForm.value|json}}</pre> -->
                  <div formArrayName="application_groups">
                    <div class="col-md-12">
                      <div class="addrem_div row" *ngFor="let application_group of application_groups().controls; let i=index" [formGroupName]="i" style="border-bottom:1px solid #cccccc; padding-bottom:26px;">


                        <!-- <div class="col-md-12 p_0">
                          <label>Name *</label>
                          <input type="text" class="form-control" formControlName="group_name" id="group_name">
                        </div> -->


                        <!-- ------New--- -->
                        <div class="col-md-12 p_0" *ngIf="this.pageType !== 'edit-site'">
                            <label>Name *</label>
                            <input type="text" class="form-control" formControlName="group_name" id="group_name">
                        </div>
                        <div class="m_r_16 full_width" *ngIf="this.pageType === 'edit-site'">
                            <label>Name *</label>
                            <input type="text" formControlName="group_name" class="form-control" id="group_name">
                        </div>
                        <!-- ------New--- -->
                        <div *ngIf="this.pageType === 'edit-site'" class="full_width">
                          <button type="button" [disabled]="makeBtnDisable" (click)="showListOfUsers(i)" style="cursor: pointer;
                          border: 1px solid #ccc;
                          height: 30px;
                          border-radius: 4px;
                          line-height: 30px;
                          padding: 0 15px;
                          margin: 0;
                          font-family: 'Roboto-Regular';margin-top:28px;width:100%;text-align:center;">Associate user</button>

                        </div>

                        <a class="add_more" *ngIf="i <= 0" (click)="addQuantity()" style="top:0px!important"><span class="sprite_icon plus_blue" ></span>Add more</a>
                        <!-- <a *ngIf="i > 0"><span class="sprite_icon cross_red hand_cursor" (click)="removeQuantity(i, application_group)"></span></a> -->
                      </div>
                      <br><br><br><br>
                    </div>
                  </div>

                  <div class="row m_b_0">
                    <div class="col-md-12">
                      <label>Description</label>
                      <textarea class="form-control" formControlName="group_description"
                        id="group_description"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="horizontal_line">
            <div class="form_actions text-right">
              <button *ngIf="showSavebtn" mat-raised-button color="primary" type="submit"
                [disabled]="!uForm.valid">Create Sites & Applications</button>
              <button  *ngIf="showUpdateBtn" mat-raised-button color="primary" type="button" [disabled]="!(uForm.valid && uForm.dirty)"
                (click)="saveDevice()">Update Sites & Applications</button>
              <button mat-stroked-button color="warn" (click)="goBackToPage()" type="button">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
